import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

const ChangePassword = ({ onClose }) => {
  const { changePassword, error, clearError } = useApp();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [localError, setLocalError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    setLocalError('');
    
    if (newPassword !== confirmPassword) {
      setLocalError('New passwords do not match');
      return;
    }

    const success = await changePassword(currentPassword, newPassword, confirmPassword);
    if (success) {
      setSuccess(true);
      setTimeout(onClose, 2000);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="change-password-modal">
        <h3>Change Password</h3>
        {(error || localError) && <div className="error-message">{error || localError}</div>}
        {success && <div className="success-message">Password changed successfully!</div>}
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Current Password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <div className="form-actions">
            <button type="button" className="secondary-button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="primary-button">
              Change Password
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ChangePassword; 